import Box from '@mui/material/Box';
import React, { memo } from 'react';

import iosImage from '../../../../assets/app-store/App_Store_Badge_US-UK_RGB.svg';
import androidImage from '../../../../assets/app-store/google-play-badge.png.webp';
import config from '../../../../config';

const MobileStoreButtonComponent = ({ store, height = 75, width = 255, linkStyles, linkProps }) => {
  const imageLinks = {
    ios: iosImage,
    android: androidImage,
  };

  const storeHrefs = {
    ios: config.iosStoreLink,
    android: config.androidStoreLink,
  };

  const defaultLinkStyles = {
    display: 'inline-block',
    overflow: 'hidden',
    textDecoration: 'none',
    height,
    width,
    background: `url(${imageLinks[store]}) no-repeat`,
    backgroundSize: 'contain',
    backgroundPosition: '50% 50%',
    padding: 0,
    ...linkStyles,
  };

  return (
    <Box
      component="a"
      href={storeHrefs[store]}
      rel="noopener noreferrer"
      sx={defaultLinkStyles}
      target="_blank"
      {...linkProps}
    />
  );
};

MobileStoreButtonComponent.displayName = 'MobileStoreButton';
const MobileStoreButton = memo(MobileStoreButtonComponent);

export default MobileStoreButton;
